import { docStatuses } from "src/api/config/systemSwitch";
import {
  Send,
  Check,
  Clock,
  Close,
  Modification,
  Pencil,
  ArchiveAddIcon,
} from "src/components/ui-icons/card";

type Props = {
  statuses: any[];
};

const HistoryStatusesMobile = ({ statuses }: Props) => {
  const getId = (value: any): number | undefined => {
    if (value == null) return undefined;
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      const num = Number(value);
      return Number.isFinite(num) ? num : undefined;
    }
    if (typeof value.get_lookupId === "function") return value.get_lookupId();
    if (typeof value.ID === "number") return value.ID;
    if (typeof value.Id === "number") return value.Id;
    if (typeof value.id === "number") return value.id;
    return undefined;
  };

  const getTitle = (value: any): string => {
    if (value == null) return "";
    if (typeof value.get_lookupValue === "function") return value.get_lookupValue();
    if (typeof value.Title === "string") return value.Title;
    if (typeof value.title === "string") return value.title;
    return String(value);
  };

  const hasStatus = (statusId: number) =>
    Array.isArray(statuses) && statuses.some((item: any) => getId(item) === statusId);

  const countStatus = (statusId: number) =>
    Array.isArray(statuses)
      ? statuses.filter((item: any) => getId(item) === statusId).length
      : 0;

  return (
    <div className="flex items-center text-sm text-[#111928]">
      {(hasStatus(docStatuses.agreed) ||
        hasStatus(docStatuses.approved) ||
        hasStatus(docStatuses.public)) && <Check />}
      {hasStatus(docStatuses.sendApproval) && <Send />}
      {hasStatus(docStatuses.edited) &&
        countStatus(docStatuses.sendApproval) === 0 &&
        countStatus(docStatuses.sendRevision) === 0 && <Pencil />}
      {(hasStatus(docStatuses.waitApproval) || hasStatus(docStatuses.review)) && (
        <Clock />
      )}
      {hasStatus(docStatuses.cancel) && <Close />}
      {hasStatus(docStatuses.sendRevision) && <Modification />}
      {hasStatus(docStatuses.sendArchive) && <ArchiveAddIcon />}
      &nbsp;&nbsp;
      {Array.isArray(statuses) &&
        statuses.map((item: any, idx: number) => (
          <>
            {idx < statuses.length - 1 ? (
              <span>{getTitle(item)},&nbsp;</span>
            ) : (
              <span>
                {getTitle(item) === "На пересмотр"
                  ? "Отправлен на пересмотр"
                  : getTitle(item)}
              </span>
            )}
          </>
        ))}
    </div>
  );
};

export default HistoryStatusesMobile;
